class LogicGroup {
  constructor() {
    const data = arguments[0] || {};
    this.id = data.id || null;
    this.conditions = data.conditions || [];
    this.modifiers = data.modifiers || [];
    this.filters = data.filters || [];
    this.logic_filters = data.logic_filters || [];
  }

  debug() {
    if (!this._debugPrefix) {
      this._debugPrefix = `LogicGroup[id=${this.id}].debug()`;
    }
    const args = [this._debugPrefix, ...arguments];
    if (console) {
      if (console.debug) {
        console.debug.apply(null, args);
      } else {
        console.log.apply(null, args);
      }
    }
  }

  addLogicCondition(condition) {
    this.conditions.push(condition);
  }

  removeLogicCondition(condition) {
    let idx = this.conditions.indexOf(condition);
    if (idx !== -1) {
      this.conditions.splice(idx, 1);
      return 1;
    }
    return 0;
  }

  addLogicFilter(logicFilter) {
    this.logic_filters.push(logicFilter);
  }

  removeLogicFilter(logicFilter) {
    let idx = this.logic_filters.indexOf(logicFilter);
    if (idx !== -1) {
      this.logic_filters.splice(idx, 1);
      return 1;
    }
    return 0;
  }

  addLogicModifier(modifier) {
    this.modifiers.push(modifier);
  }

  removeLogicModifier(modifier) {
    let idx = this.modifiers.indexOf(modifier);
    if (idx !== -1) {
      this.modifiers.splice(idx, 1);
      return 1;
    }
    return 0;
  }

  addLocationFilter(filter) {
    this.filters.push(filter);
  }

  removeLocationFilter(filter) {
    let idx = this.filters.indexOf(filter);
    if (idx !== -1) {
      this.filters.splice(idx, 1);
      return 1;
    }
    return 0;
  }

  logicResultForRecapResponse(
    recapResponse,
    formResponse = null,
    fieldResponsesWithPendingLogicChecks = null,
    rootObjectForLogicCheck = null
  ) {
   // this.debug("logicResultForRecapResponse()");
    let result = this.conditions.every((condition) => {
      return condition.logicResultForRecapResponse(
        recapResponse,
        formResponse,
        fieldResponsesWithPendingLogicChecks,
        rootObjectForLogicCheck
      )
    }
    );
    if (result) {
      result = this.logic_filters.every((logicFilter) =>
        logicFilter.logicResultForRecapResponse(recapResponse)
      );
    }
    return result;
  }
}

export default LogicGroup;
